<template>
	<img
		v-watermark
		:class="{'img-watermark': true, [className]: true}"
		:src="imageUrl"
	/>
</template>

<script>
	import fakeImage from '@/assets/bg2.png'

	export default {
		props: {
			src: {
				default: '',
				type: String
			},
			className: {
				default: '',
				type: String
			}
		},
		computed: {
			imageUrl () {
				const localEnv = window.location.hostname === 'localhost'

				return localEnv ? fakeImage : this.src
			}
		}
	}
</script>
